import { Patient } from '../../models/patient';
import client from '../httpclient';

const getPatientDetails = (
  patientId: string,
): Promise<{patient: Patient}> => client.get(`/re/v1/patient/${patientId}`);

export default getPatientDetails;
